import React, { useEffect, useState } from "react";

import Layout from "../components/layout";
import Metadata from "../components/metadata";
import Contact from "../components/contact";

import "../styles/main.scss";

const IndexPage = () => {
    const generateCurrentYear = () => new Date().getFullYear();
    const [currentYear, setCurrentYear] = useState(generateCurrentYear());

    useEffect(() => {
        // overwrite the hard-coded year with the actual current year at time of
        // user visit
        setCurrentYear(generateCurrentYear());
    }, []);

    return (
        <Layout>
            <Metadata
                title="The online community for travellers and backpackers"
                description="Meet friendly travelers while backpacking around the world in hostels"
            />

            <h1 className="title">Community Traveller</h1>
            <p>
                Meet travelers while backpacking around the world in{" "}
                <a
                    style={{ textDecoration: "underline" }}
                    href="https://hostelsearchengine.com/"
                >
                    hostels
                </a>
                .
            </p>
            <p>Coming {currentYear}</p>
            <div>
                <Contact />
            </div>
        </Layout>
    );
};

export default IndexPage;
